import { useQuery } from '@tanstack/vue-query';
import { useGmApi } from '@/composables/useGmApi';
import type { UseQueryOptions } from '@/types/query';
import { TeamPosition } from '@/types/positions';
import { useMainStore } from '@/stores/mainStore';
import { computed } from 'vue';
import { getTeamPositionsQueryKey } from '@/utils/queries/teams';

type UsePositionQueryOptions<T> = UseQueryOptions<TeamPosition[], T, null>;

export const POSITION_QUERY_STALE_TIME = 60000; // One minute

export function usePositionQuery<T = TeamPosition[]>(
  ...args: [UsePositionQueryOptions<T>?]
) {
  const { getTeamPositions } = useGmApi();
  const mainStore = useMainStore();
  const teamTwrn = computed(() => mainStore.teamTwrn);
  const queryKey = computed(() => getTeamPositionsQueryKey(teamTwrn.value));
  const query = useQuery({
    staleTime: POSITION_QUERY_STALE_TIME, // One minute
    retry: false,
    ...(args[0] ?? {}),
    queryKey,
    queryFn: () => getTeamPositions(teamTwrn.value!),
  });

  return query;
}
